import { SxProps, Theme } from "@mui/material";
import WorkItemSelectField from "../shared/WorkItemSelectField";


interface IWorkItemSearchFieldStatusProps {
    idSuffix: string,
    labelProps?: SxProps<Theme> | undefined,
    onChange: (e: number[]) => void,
    multiple?: boolean,
    options: any[],
    label?: string
}

const WorkItemSearchFieldStatus = (props: IWorkItemSearchFieldStatusProps) => {
    return (
        <>
            <WorkItemSelectField
                label={props.label ?? "Status"}
                labelProps={props.labelProps}
                idSuffix={props.idSuffix}
                multiple={props.multiple === undefined ? true : props.multiple}
                options={props.options}
                onChange={s => props.onChange(s)} />
        </>
    );
}

export default WorkItemSearchFieldStatus;